import React from 'react';
import { Button } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { useTheme } from '../../contexts/ThemeContext';
import './index.css';

const ThemeToggle = ({ className = '', size = 'middle' }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Button
      type="text"
      icon={isDarkMode ? <BulbOutlined /> : <BulbFilled />}
      onClick={toggleTheme}
      className={`theme-toggle ${className}`}
      size={size}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    />
  );
};

export default ThemeToggle; 